import React from "react";
import { useCart } from "../context/CartContext";
import styles from "./AddOns.module.css";

const addOns = [
  {
    id: "quad",
    name: "Quad Bike Ride",
    price: 100,
    features: ["Own helmets", "Partner", "Select 30 seats"],
    image:
      "https://images.unsplash.com/photo-1533130061792-64b345e4a833?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "buggy",
    name: "Dune Buggy Ride",
    price: 200,
    features: ["Two helmets", "Partner", "Select 2 seats"],
    image:
      "https://images.unsplash.com/photo-1519752594763-9edf9caea336?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "vip",
    name: "VIP Seating",
    price: 80,
    features: ["View included", "Features", "VIP seating included"],
    image:
      "https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?auto=format&fit=crop&w=400&q=80",
  },
];

function AddOns() {
  const { addToCart } = useCart();

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Optional Add-Ons</h2>

        <div className="row g-3">
          {addOns.map((item) => (
            <div key={item.id} className="col-12 col-md-4">
              <div className={styles.card}>
                <div className={styles.imageWrap}>
                  <img
                    src={item.image}
                    alt={item.name}
                    className={styles.image}
                  />
                  <span className={styles.priceBadge}>AED {item.price}</span>
                </div>

                <div className={styles.body}>
                  <p className={styles.name}>{item.name}</p>
                  <ul className={styles.featureList}>
                    {item.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                  <button
                    type="button"
                    className={styles.addBtn}
                    onClick={() =>
                      addToCart({
                        id: item.id,
                        name: item.name,
                        price: item.price,
                        type: "addon",
                      })
                    }
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AddOns;
